import '../styles/notifications.scss';
import { Badge } from '@mui/material';
import { getNotifications, markAllNotificationsAsRead, markNotificationAsRead } from './api';
import { $pushNotifications, setPushNotification } from '../store/pushNotifications';
import { useUnit } from 'effector-react';
import { timeAgoModern } from '../shared/utils';

export const NotificationsList = () => {
  const pushNotifications = useUnit($pushNotifications);

  const markAsRead = async (id, url) => {
    try {
      await markNotificationAsRead({ id: id });
      const notifications = await getNotifications();
      setPushNotification(notifications);
    }
    catch (error) {
      console.log(error);
    }
    if (url)
      window.location.href = url;

  };

  const markAllAsRead = () => {
    const unreadNotifications = pushNotifications
      .filter(notification => !notification.read)
      .map(notification => notification.id);
    markAllNotificationsAsRead({ ids: unreadNotifications })
      .then(_ => {
        getNotifications()
          .then(data => {
            setPushNotification(data);
          })
          .catch(error => {
            console.log(error);
          })
      })
      .catch(error => {
        console.log(error);
      });
  };

  const unreadCount = pushNotifications.filter(n => !n.isRead).length;

  return (
    <div className="notifications notifications--embedded">
      <div className="notifications__header">
        <div className="notifications__header-left">
          <h3 className="notifications__title">Уведомления</h3>
          {unreadCount > 0 && (
            <Badge
              badgeContent={unreadCount}
              color="primary"
              className="notifications__badge"
            />
          )}
        </div>
        <div className="notifications__header-right">
          {unreadCount > 0 && (
            <button
              className="notifications__mark-read"
              onClick={markAllAsRead}
            >
              Прочитать все
            </button>
          )}
        </div>
      </div>

      <div className="notifications__list">
        {pushNotifications.length === 0 ? (
          <div className="notifications__empty">
            <p>Нет новых уведомлений</p>
          </div>
        ) : (
          pushNotifications.map(notification => (
            <div
              key={notification.id}
              className={`notifications__item ${!notification.isRead ? 'notifications__item--unread' : ''}`}
              onClick={() => markAsRead(notification.id, notification.redirectUrl)}
            >
              <div className="notifications__item-content">
                <div className="notifications__item-info">
                  <p className="notifications__item-message">
                    <b>{notification.title}</b>
                  </p>
                  <p className="notifications__item-message">
                    {notification.message}
                  </p>
                  <span className="notifications__item-time">
                    {timeAgoModern(notification.createdAt)}
                  </span>
                </div>
                {!notification.isRead && (
                  <span className="notifications__item-unread-dot" />
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};